import { render, staticRenderFns } from "./WebsiteView.vue?vue&type=template&id=63a96092&scoped=true&"
import script from "./WebsiteView.vue?vue&type=script&lang=js&"
export * from "./WebsiteView.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteView.vue?vue&type=style&index=0&id=63a96092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a96092",
  null
  
)

export default component.exports